import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface ModifierPictoProps extends pictoProps {
}

export interface ModifierPictoState extends pictoState {
}

export class ModifierPicto extends Picto<ModifierPictoProps,ModifierPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.modifierPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(ModifierPicto);
